import { type SyncState } from '@prisma/client'

export const getStructuredDataStatus = (status: SyncState) => {
	if (!status) {
		return undefined
	}
	if (status === 'Cancelled') {
		return 'https://schema.org/EventCancelled"'
	}
	return 'EventScheduled'
}
